// Muted, desaturated status tones — deliberately secondary to the crimson-pink brand accent
// (see theme.css: --status-active/--status-paused/--status-error/--status-neutral).
const TONE_BY_STATUS = {
  active: 'active',
  enabled: 'active',
  paused: 'paused',
  disabled: 'paused',
  error: 'error',
  revoked: 'error',
  archived: 'neutral',
  // A/B test lifecycle (draft -> running -> completed -> archived) reuses the same four tones.
  draft: 'neutral',
  running: 'active',
  completed: 'neutral',
  // Configuration-version lifecycle (draft -> published -> archived) reuses the same tones again.
  published: 'active',
  // Supply authorization verification status (migrations/024_supply_quality_transparency.sql) --
  // CONFIGURED is "nothing checked yet" (neutral), VALID/VERIFIED are confirmed-good (active),
  // UNVERIFIED is "checked, no match found" (paused -- not necessarily wrong, needs attention),
  // CONFLICT/ERROR are real problems (error).
  configured: 'neutral',
  valid: 'active',
  verified: 'active',
  unverified: 'paused',
  conflict: 'error',
  // IVT policy actions (ALLOW/ALLOW_WITH_SIGNAL/LOWER_PRIORITY/BLOCK) -- same four-tone system,
  // ordered by how consequential each action is.
  allow: 'active',
  allow_with_signal: 'paused',
  lower_priority: 'paused',
  block: 'error',
  // IVT classifications (UNKNOWN/LOW_RISK/SUSPICIOUS/HIGH_RISK/IVT_CONFIRMED) -- same escalation.
  unknown: 'neutral',
  low_risk: 'active',
  suspicious: 'paused',
  high_risk: 'paused',
  ivt_confirmed: 'error',
};

export default function StatusBadge({ status }) {
  const normalized = String(status || '').toLowerCase();
  const tone = TONE_BY_STATUS[normalized] || 'neutral';
  return <span className={`status-badge status-badge--${tone}`}>{status}</span>;
}
